//components/MenuCategories/MenuCategories.jsx
import React from "react";

// CSS
import "./menu-categories.css";

// Sample Menu Categories Data
const menuCategories = [
  {
    id: 1,
    category: "late_night",
    image:
      "https://images.pexels.com/photos/64208/pexels-photo-64208.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    id: 2,
    category: "dinner",
    image:
      "https://images.pexels.com/photos/2673353/pexels-photo-2673353.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    id: 3,
    category: "lunch",
    image:
      "https://images.pexels.com/photos/70497/pexels-photo-70497.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },

  {
    id: 4,
    category: "breakfast",
    image:
      "https://images.pexels.com/photos/376464/pexels-photo-376464.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },

  {
    id: 5,
    category: "snacks",
    image:
      "https://images.pexels.com/photos/1647163/pexels-photo-1647163.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    id: 6,
    category: "drinks",
    image:
      "https://images.pexels.com/photos/2789328/pexels-photo-2789328.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    id: 7,
    category: "pre_order",
    image:
      "https://images.pexels.com/photos/8112951/pexels-photo-8112951.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    id: 8,
    category: "catering",
    image:
      "https://images.pexels.com/photos/674574/pexels-photo-674574.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
];

const MenuCategories = ({ onCategoryClick }) => {
  return (
    <section className="menu-categories" id="menu-categories">
      <div className="menu-categories-container">
        <h2 className="menu-categories-title">Menu Categories</h2>
        <div className="menu-categories-content">
          {menuCategories.map((category) => (
            <div key={category.id} className="menu-category">
              <img
                src={category.image}
                alt={category.category}
                className="menu-category-img"
              />

              <div className="menu-category-details">
                <h3 className="menu-category-title">
                  {category.category.replace(/_/g, " ").toUpperCase()}
                </h3>
                <a
                  href="/menu#full-menu"
                  className="menu-category-order-btn btn btn-primary"
                  onClick={() => onCategoryClick(category.category)}
                >
                  View Menu
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MenuCategories;
